import { combineReducers } from 'redux'
import image from './image';
import modal from './modal';

export default combineReducers({
    image,
    modal,
})